// extracted by mini-css-extract-plugin
export var labelWrapper = "_fu-0";